<template>
  <span
    class="rounded-full flex h-14 w-14 items-center justify-center bg-[#EA1502] p-2"
    aria-hidden="true"
  >
    <RevIllustration
      src="/mine-my-phone/icons/bell--flat.svg"
      alt=""
      :width="10"
      :height="10"
    />
  </span>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'
</script>
